export var StepNames;
(function (StepNames) {
    StepNames["ENTRY"] = "ENTRY";
    StepNames["VERIFY_IDENTITY"] = "VERIFY_IDENTITY";
    StepNames["DOCUMENT_SELECTION"] = "DOCUMENT_SELECTION";
    StepNames["VERIFICATION_PROCESS"] = "VERIFICATION_PROCESS";
    StepNames["SUCCESS"] = "SUCCESS";
    StepNames["PARTIAL_SUCCESS"] = "PARTIAL_SUCCESS";
    StepNames["ERROR"] = "ERROR";
    StepNames["REJECTED"] = "REJECTED";
})(StepNames || (StepNames = {}));
export var DocumentStatus;
(function (DocumentStatus) {
    DocumentStatus["REQUIRED"] = "REQUIRED";
    DocumentStatus["SUBMITTED"] = "SUBMITTED";
    DocumentStatus["VERIFIED"] = "VERIFIED";
    DocumentStatus["REJECTED"] = "REJECTED";
    DocumentStatus["PENDING"] = "PENDING";
    DocumentStatus["NOT_UPLOADED"] = "NOT_UPLOADED";
})(DocumentStatus || (DocumentStatus = {}));
export var VerificationType;
(function (VerificationType) {
    VerificationType["IDENTITY"] = "IDENTITY";
    VerificationType["DOCUMENT"] = "DOCUMENT";
})(VerificationType || (VerificationType = {}));
export var IdentityDocuments;
(function (IdentityDocuments) {
    IdentityDocuments["PASSPORT"] = "PASSPORT";
    IdentityDocuments["DRIVING_LICENSE"] = "DRIVING_LICENSE";
})(IdentityDocuments || (IdentityDocuments = {}));
//# sourceMappingURL=index.js.map